import React from 'react';

type LargePlusProps = {
  color?: string;
  size?: number;
};

export function LargePlus({ color = 'var(--color-gray-30)', size = 20 }: LargePlusProps) {
  return (
    <svg fill='none' height={size} viewBox='0 0 21 20' width={size} xmlns='http://www.w3.org/2000/svg'>
      <rect fill={color} height='14' rx='0.5' width='2.5' x='9.54883' y='3' />
      <rect fill={color} height='14' rx='0.5' transform='rotate(90 17.7988 8.75)' width='2.5' x='17.7988' y='8.75' />
    </svg>
  );
}
